import React, { useEffect } from "react";
import Footer from "../header-footer/Footer";
import Navbar from "../header-footer/Navbar";
import PrivacyPolicyKnowledgeBase from "../privacy-policy/PrivacyPolicyKnowledgeBase";
import FeesAndCompensationNew from "./FeesAndCompensationNew";
// import TermsAndConditionsNewContent from "./TermsAndConditionsNewContent";

/**
 * FeesAndCompensation Component
 * 
 * Overview:
 * 
 * 
 * Details:
 * 
 * 
 * Usage:
 * 
 * Dependencies:
 * - React: This component is built using React.
 * - Navbar: This component is imported and used within the TermsAndConditionsNew component.
 * - PrivacyPolicyKnowledgeBase: This component is imported and used within the TermsAndConditionsNew component.
 * - TermsAndConditionsNewContent: This component is imported and used within the TermsAndConditionsNew component.
 * - Footer: This component is imported and used within the TermsAndConditionsNew component.
 */

export default function FeesAndCompensation() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="privacy-policy-main-div">
      <Navbar />
      <div className="privacy-policy-page-title-block">
        <h1>Fees and Compensation Disclosures</h1>
      </div>
      <PrivacyPolicyKnowledgeBase />
      <FeesAndCompensationNew displayOnWebApp={false} />
      <Footer />
    </div>
  );
}
